/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill, .bg {
    color: inherit;
  }
`
export default class InformationIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" css={Color}>
        <g id="그룹_15578" data-name="그룹 15578" transform="translate(14179 13104)">
          <rect id="사각형_9734" data-name="사각형 9734" width="30" height="30" transform="translate(-14179 -13104)" fill="red" opacity="0"/>
          <g id="그룹_15577" data-name="그룹 15577">
            <path id="패스_6810" className="bg" data-name="패스 6810" d="M1075.96,568.57a10,10,0,1,0,10,10A10,10,0,0,0,1075.96,568.57Z" transform="translate(-13088.04 -12510.43) rotate(180)" fill="#2c346a"/>
            <path id="합치기_450" className="fill" data-name="합치기 450" d="M.4,9.561a.4.4,0,0,1-.4-.4V3.912a.4.4,0,0,1,.4-.4H1.5a.4.4,0,0,1,.4.4V9.16a.4.4,0,0,1-.4.4ZM0,.952A.959.959,0,0,1,.952,0a.951.951,0,0,1,.672.28A.931.931,0,0,1,1.9.952a.952.952,0,1,1-1.9,0Z" transform="translate(-14164.824 -13093.648)" fill="#fff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
          </g>
        </g>
      </svg>
    )
  }
}
